import script from "./Editor.vue?vue&type=script&lang=ts&setup=true"
export * from "./Editor.vue?vue&type=script&lang=ts&setup=true"

import "./Editor.vue?vue&type=style&index=0&id=d56a56f4&lang=css"

const __exports__ = script;

export default __exports__